import React from "react";
import { Tabs } from "antd";
import Endereco from "../../page/Recadastramento/Componentes/Endereco";
import Contato from "../../page/Recadastramento/Componentes/Contato";

const FormContato = ({ form,modoSomenteLeitura }) => {
  return (
      <>
        <Endereco
              disabled={modoSomenteLeitura}
              modoSomenteLeitura = {modoSomenteLeitura}
              form={form}
              nome={["dependente","endereco"]}
              onClear={() => form.resetFields(["dependente","endereco"])}
            />
       
            <Contato
              disabled={modoSomenteLeitura}
              modoSomenteLeitura={modoSomenteLeitura}
              form={form}
              nome={["dependente", "contato"]}
              onClear={() => form.resetFields(["dependente", "contato"])}
            />
      
      </>

  );
};

export default FormContato;
